import {FC, PropsWithChildren} from "react";
import {ScriptObserver, ScriptPlaceholderProps} from "../script-injector";
import {WebComponent, WebComponentProps} from "./WebComponent";

// prettier-ignore
export interface WebComponentObserverProps
    extends WebComponentProps, ScriptPlaceholderProps {
    "script-id": string;
}

export const WebComponentObserver: FC<
  PropsWithChildren<WebComponentObserverProps>
> = ({
  "script-id": id,
  loading,
  failure,
  element,
  attributes,
  placeholder,
  children
}) => {
  return (
    <ScriptObserver id={id} loading={loading} failure={failure}>
      <WebComponent
        element={element}
        attributes={attributes}
        placeholder={placeholder}>
        {children}
      </WebComponent>
    </ScriptObserver>
  );
};
